import React from "react";

import {
  parsePgnRichText,
  type PgnRichTextNode,
} from "./parsePgnRichText";

type PgnRichTextProps = {
  text: string | null | undefined;
};

const linkClassName =
  "font-semibold text-blue-600 underline decoration-2 underline-offset-2 hover:text-blue-700 dark:text-sky-300 dark:hover:text-sky-200";

function renderNode(node: PgnRichTextNode, key: React.Key): React.ReactNode {
  if (node.kind === "text") {
    return node.text;
  }

  const children = node.children.map((child, index) =>
    renderNode(child, `${key}.${index}`),
  );

  switch (node.tag) {
    case "strong":
      return React.createElement("strong", { key }, children);
    case "em":
      return React.createElement("em", { key }, children);
    case "u":
      return React.createElement("u", { key }, children);
    case "s":
      return React.createElement("s", { key }, children);
    case "br":
      return React.createElement("br", { key });
    case "span":
      return React.createElement(
        "span",
        { key, style: node.attrs.style },
        children,
      );
    case "a":
      if (!node.attrs.href) {
        return React.createElement(React.Fragment, { key }, children);
      }
      return React.createElement(
        "a",
        {
          key,
          className: linkClassName,
          href: node.attrs.href,
          rel: "noopener noreferrer",
          target: "_blank",
          style: node.attrs.style,
        },
        children,
      );
  }
}

export function PgnRichText({ text }: PgnRichTextProps) {
  return React.createElement(
    React.Fragment,
    null,
    parsePgnRichText(text).map((node, index) => renderNode(node, index)),
  );
}

export default PgnRichText;
